module.exports = __webpack_public_path__ + "img/ecran carte.2ea26a50.png";